<ng-container *ngIf="!!params">
    <tt-button-goto ttText="subtask_add" ttIcon="far fa-plus" ttGoto="custactedit" [ttGotoParms]="{ custact_no: '0', filterfield: 'custact_no', filtervalue: params.custact_no }"></tt-button-goto>
    <tt-button-goto
        ttText="subtasks_add_excisting_activity"
        [ttBeforeGoto]="rememberCustactLink"
        ttGoto="custactsearch"
        [ttGotoParms]="{ filterfield: '-', filtervalue: '-', custacttype: 'A' }"
    ></tt-button-goto>
    <tt-button-goto
        ttText="subtasks_add_excisting_deviation"
        [ttBeforeGoto]="rememberCustactLink"
        ttGoto="custactsearch"
        [ttGotoParms]="{ filterfield: '-', filtervalue: '-', custacttype: 'D' }"
    ></tt-button-goto>
    <tt-button-goto *ngIf="params.show_button_gantt === '1'" ttText="custact_gantt" ttGoto="custactgantt" [ttGotoParms]="{ connectto: 'custact', connectto_value: params.custact_no }"></tt-button-goto>
</ng-container>
